import React, { Component } from 'react';
import Datas from '../../data/facilities/smartclass.json';
import { Styles } from './styles/popularCourse.js';

class  PopularSmart extends Component {
    render() {
        return (
            <Styles>
                {/* Popular Course */}
                <div className="popular-course">
                    <h5>Top SmartClass Facilities</h5>
                    <div className="popular-items">
                        {
                            Datas.map((data, i) => (

                                <div className="item-box d-flex" key={i}>
                                    <div className="item-img">
                                        <img src={process.env.PUBLIC_URL + `/assets/images/${data.imgUrl}`} alt="" />
                                    </div>
                                    <div className="item-content">
                                        <p className="title">{data.facilityTitle}</p>
                                        <ul className="list-unstyled list-inline rating">
                                            <li className="list-inline-item"><i className="las la-star"></i></li>
                                            <li className="list-inline-item"><i className="las la-star"></i></li>
                                            <li className="list-inline-item"><i className="las la-star"></i></li>
                                            <li className="list-inline-item"><i className="las la-star"></i></li>
                                            <li className="list-inline-item"><i className="las la-star"></i></li>
                                        </ul>
                                        {/* <p className="price">{data.price}</p> */}
                                    </div>
                                </div>

                            ))
                        }
                    </div>
                </div>
            </Styles>
        )
    }
}

export default PopularSmart